import { render, staticRenderFns } from "./MaterialsList.vue?vue&type=template&id=0a055d33&scoped=true&"
import script from "./MaterialsList.vue?vue&type=script&lang=js&"
export * from "./MaterialsList.vue?vue&type=script&lang=js&"
import style0 from "./MaterialsList.vue?vue&type=style&index=0&id=0a055d33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a055d33",
  null
  
)

export default component.exports